import { Reveal } from "./Reveal";
import { SERVICES, scrollToId } from "@/lib/site";

export default function Services() {
  return (
    <section id="services" className="bg-graybg py-20 md:py-28">
      <div className="mx-auto max-w-[1200px] px-5 md:px-8">
        <Reveal>
          <p className="eyebrow">What we do</p>
          <h2 className="mt-4 max-w-2xl font-display text-4xl font-light leading-[1.12] text-navy md:text-5xl">
            Premium painting, engineered <em className="italic">for Florida.</em>
          </h2>
          <p className="mt-5 max-w-2xl text-[15px] leading-relaxed text-[#5c6b7a] md:text-base">
            Four disciplines. One uncompromising standard. Whether it's a moisture-resistant
            exterior or a high-end interior repaint, every SundaySea project is prepped, primed,
            and finished by hand.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-8 md:grid-cols-2">
          {SERVICES.map((s, i) => (
            <Reveal key={s.tag} delay={i * 0.07}>
              <a
                href="#contact"
                data-testid={s.testid}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToId("#contact");
                }}
                className="group block border border-[#e6e6e1] bg-white transition-shadow duration-300 hover:shadow-[0_18px_40px_rgba(13,27,43,0.10)]"
              >
                <div className="overflow-hidden">
                  <img
                    src={s.img}
                    alt={s.alt}
                    loading="lazy"
                    className="h-60 w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-[1.04] md:h-64"
                  />
                </div>
                <div className="p-7 md:p-8">
                  <div className="flex items-start justify-between gap-4">
                    <p className="eyebrow pt-1">{s.tag}</p>
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center border border-[#e6e6e1] text-navy transition-colors duration-300 group-hover:bg-amber group-hover:text-white">
                      <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                        <path d="M7 17 17 7M7 7h10v10" />
                      </svg>
                    </span>
                  </div>
                  <h3 className="mt-3 font-display text-[22px] font-medium leading-snug text-navy md:text-2xl">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-[#5c6b7a]">{s.desc}</p>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
